import { defineMessages } from 'react-intl';

export const creatingAccountMessages = defineMessages({
  creatingAccount: {
    id: 'creating_account.title',
    defaultMessage: 'We are setting up your <blue>personalized</blue> account...',
    description: 'Title of the setting up account',
  },
  thankYou: {
    id: 'creating_account.creating_account.thank_you',
    defaultMessage: 'Thank you!',
    description: 'Thank you on creating account page',
  },
  error: {
    id: 'creating_account.error',
    defaultMessage: 'An error occurred while creating your account. You will be redirected to the login page.',
    description: 'Error message when creating account fails',
  },
});
